/**
 * /component/service/ServiceItem.js
 */


import React from 'react';
import InViewMonitor from 'react-inview-monitor';
import { isUA } from '../../helper/userAgent';

const ServiceItem = props => {
  // edge用
  if(isUA('edge')){
    props.showAnim = 'show-scroll-animation';
  }
  const ItemList = props.item.map(function(v,index){
    let dotCssClass = "dot-right";
    if((index + 1) % 2 === 0){
      dotCssClass = "dot-left";
    } 
    return ( 
      <InViewMonitor
        classNameNotInView=''
        classNameInView='show-scroll-animation'
        key={index}
      >
        <div className={`service-item scroll-animation-cont ${dotCssClass} ${props.showAnim}`} key={index}>
        <div className="item-inner">
        <div className="mask-slide-in-out"></div>
          <h2 className="item-title">{v.title}</h2>
          <div className="item-comment" dangerouslySetInnerHTML={{__html:v.comment}}></div>
        </div>
      </div>
    </InViewMonitor>
    )
  })
  
  return (
    <div>
      {ItemList}
    </div>
  )
}
export default ServiceItem;


// WEBPACK FOOTER //
// ./src/component/service/ServiceItem.js